import { render, staticRenderFns } from "./FormGetSingleProductBySKU.vue?vue&type=template&id=2efb37d4&scoped=true&"
import script from "./FormGetSingleProductBySKU.vue?vue&type=script&lang=js&"
export * from "./FormGetSingleProductBySKU.vue?vue&type=script&lang=js&"
import style0 from "./FormGetSingleProductBySKU.vue?vue&type=style&index=0&id=2efb37d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb37d4",
  null
  
)

export default component.exports